import { isCampaignComponentVariable } from "src/shared/store/campaign-component/variable/model/CampaignComponentVariable";
import { ComponentVariableMutable } from "../ComponentVariableMutable";
import { isCampaignComponentEnumVariable } from "src/shared/store/campaign-component/variable/model/CampaignComponentEnumVariable";
import { EnumComponentVariableMutable } from "../EnumComponentVariableMutable";
import { ComponentSettingMutable } from "../ComponentSettingMutable";
import { isCampaignComponentSocket } from "src/shared/store/campaign-component/variable/model/CampaignComponentSocket";
import { ComponentSocketMutable } from "../ComponentSocketMutable";
import { EnumListComponentVariableMutable } from "../EnumListComponentVariableMutable";
import { isCampaignComponentEnumListVariable } from "src/shared/store/campaign-component/variable/model/CampaignComponentEnumListVariable";
export const createComponentSettingMutable = (componentMutableKey, type, setting) => {
    if (isCampaignComponentEnumVariable(setting)) {
        return new EnumComponentVariableMutable(componentMutableKey, type, setting);
    }
    if (isCampaignComponentEnumListVariable(setting)) {
        return new EnumListComponentVariableMutable(componentMutableKey, type, setting);
    }
    if (isCampaignComponentVariable(setting)) {
        return new ComponentVariableMutable(componentMutableKey, type, setting);
    }
    if (isCampaignComponentSocket(setting)) {
        return new ComponentSocketMutable(componentMutableKey, type, setting);
    }
    return new ComponentSettingMutable(componentMutableKey, type, setting);
};
